import { render, staticRenderFns } from "./RiseupButtonPlayground.vue?vue&type=template&id=69858277&scoped=true&"
import script from "./RiseupButtonPlayground.vue?vue&type=script&lang=js&"
export * from "./RiseupButtonPlayground.vue?vue&type=script&lang=js&"
import style0 from "./RiseupButtonPlayground.vue?vue&type=style&index=0&id=69858277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69858277",
  null
  
)

export default component.exports